"use strict";
/* tslint:disable */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhisperApi = exports.WhisperApiFactory = exports.WhisperApiFp = exports.WhisperApiAxiosParamCreator = exports.UsageApi = exports.UsageApiFactory = exports.UsageApiFp = exports.UsageApiAxiosParamCreator = exports.AiApi = exports.AiApiFactory = exports.AiApiFp = exports.AiApiAxiosParamCreator = exports.AgentApi = exports.AgentApiFactory = exports.AgentApiFp = exports.AgentApiAxiosParamCreator = exports.AIServiceAgentSourceDtoTypeEnum = exports.AIServiceAgentInputDtoTextFieldTypeEnum = exports.AIServiceAgentInputDtoTypeEnum = exports.AIServiceAgentIconColorDto = exports.AIServiceAgentCategoryDtoTypeEnum = void 0;
/* eslint-disable */
/**
 * Nimbus AI service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
const axios_1 = __importDefault(require("axios"));
// @ts-ignore
const base_1 = require("./base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
exports.AIServiceAgentCategoryDtoTypeEnum = {
    System: 'system',
    Private: 'private',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AIServiceAgentIconColorDto = {
    Slate: 'slate',
    Gray: 'gray',
    Zinc: 'zinc',
    Neutral: 'neutral',
    Stone: 'stone',
    Red: 'red',
    Orange: 'orange',
    Amber: 'amber',
    Yellow: 'yellow',
    Lime: 'lime',
    Green: 'green',
    Emerald: 'emerald',
    Teal: 'teal',
    Cyan: 'cyan',
    Sky: 'sky',
    Blue: 'blue',
    Indigo: 'indigo',
    Violet: 'violet',
    Purple: 'purple',
    Fuchsia: 'fuchsia',
    Pink: 'pink',
    Rose: 'rose',
};
exports.AIServiceAgentInputDtoTypeEnum = {
    Text: 'text',
    File: 'file',
};
exports.AIServiceAgentInputDtoTextFieldTypeEnum = {
    Single: 'single',
    Multi: 'multi',
};
exports.AIServiceAgentSourceDtoTypeEnum = {
    Note: 'note',
    Folder: 'folder',
};
/**
 * AgentApi - axios parameter creator
 * @export
 */
const AgentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new agent for an organization
         * @param {string} org
         * @param {AIServiceAgentPayloadDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCreateAgent: async (org, data, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiCreateAgent', 'org', org);
            // verify required parameter 'data' is not null or undefined
            (0, common_1.assertParamExists)('apiCreateAgent', 'data', data);
            const localVarPath = `/orgs/{org}/agents`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteAgent: async (org, id, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiDeleteAgent', 'org', org);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiDeleteAgent', 'id', id);
            const localVarPath = `/orgs/{org}/agents/{id}`
                .replace(`{${'org'}}`, encodeURIComponent(String(org)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Duplicate an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {AIServiceAgentDuplicatePayloadDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDuplicateAgent: async (org, id, data, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiDuplicateAgent', 'org', org);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiDuplicateAgent', 'id', id);
            // verify required parameter 'data' is not null or undefined
            (0, common_1.assertParamExists)('apiDuplicateAgent', 'data', data);
            const localVarPath = `/orgs/{org}/agents/{id}/duplicate`
                .replace(`{${'org'}}`, encodeURIComponent(String(org)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAgentByGlobalId: async (org, id, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAgentByGlobalId', 'org', org);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAgentByGlobalId', 'id', id);
            const localVarPath = `/orgs/{org}/agents/{id}`
                .replace(`{${'org'}}`, encodeURIComponent(String(org)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all agent categories for an organization
         * @param {string} org
         * @param {boolean} [withCount] Include count of agents in each category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAgentCategories: async (org, withCount, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAgentCategories', 'org', org);
            const localVarPath = `/orgs/{org}/agent-categories`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (withCount !== undefined) {
                localVarQueryParameter['withCount'] = withCount;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get agents by category
         * @param {string} org
         * @param {string} globalId Category globalId (all, other, or specific category ID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAgentsByCategory: async (org, globalId, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAgentsByCategory', 'org', org);
            // verify required parameter 'globalId' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAgentsByCategory', 'globalId', globalId);
            const localVarPath = `/orgs/{org}/agent-categories/agents`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (globalId !== undefined) {
                localVarQueryParameter['globalId'] = globalId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all agents for an organization
         * @param {string} org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAllAgents: async (org, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAllAgents', 'org', org);
            const localVarPath = `/orgs/{org}/agents`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {AIServiceAgentUpdatePayloadDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateAgent: async (org, id, data, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAgent', 'org', org);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAgent', 'id', id);
            // verify required parameter 'data' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAgent', 'data', data);
            const localVarPath = `/orgs/{org}/agents/{id}`
                .replace(`{${'org'}}`, encodeURIComponent(String(org)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update categories for an agent
         * @param {string} org
         * @param {string} id
         * @param {AIServiceApiUpdateAgentCategoriesRequestDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateAgentCategories: async (org, id, data, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAgentCategories', 'org', org);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAgentCategories', 'id', id);
            // verify required parameter 'data' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateAgentCategories', 'data', data);
            const localVarPath = `/orgs/{org}/agents/{id}/categories`
                .replace(`{${'org'}}`, encodeURIComponent(String(org)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AgentApiAxiosParamCreator = AgentApiAxiosParamCreator;
/**
 * AgentApi - functional programming interface
 * @export
 */
const AgentApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AgentApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a new agent for an organization
         * @param {string} org
         * @param {AIServiceAgentPayloadDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCreateAgent(org, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCreateAgent(org, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeleteAgent(org, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeleteAgent(org, id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Duplicate an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {AIServiceAgentDuplicatePayloadDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDuplicateAgent(org, id, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDuplicateAgent(org, id, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetAgentByGlobalId(org, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetAgentByGlobalId(org, id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get all agent categories for an organization
         * @param {string} org
         * @param {boolean} [withCount] Include count of agents in each category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetAgentCategories(org, withCount, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetAgentCategories(org, withCount, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get agents by category
         * @param {string} org
         * @param {string} globalId Category globalId (all, other, or specific category ID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetAgentsByCategory(org, globalId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetAgentsByCategory(org, globalId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get all agents for an organization
         * @param {string} org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetAllAgents(org, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetAllAgents(org, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update an agent by ID
         * @param {string} org
         * @param {string} id
         * @param {AIServiceAgentUpdatePayloadDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateAgent(org, id, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateAgent(org, id, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update categories for an agent
         * @param {string} org
         * @param {string} id
         * @param {AIServiceApiUpdateAgentCategoriesRequestDto} data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateAgentCategories(org, id, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateAgentCategories(org, id, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AgentApiFp = AgentApiFp;
/**
 * AgentApi - factory interface
 * @export
 */
const AgentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AgentApiFp)(configuration);
    return {
        /**
         * Create a new agent for an organization
         * @param {AgentApiApiCreateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCreateAgent(requestParameters, options) {
            return localVarFp
                .apiCreateAgent(requestParameters.org, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an agent by ID
         * @param {AgentApiApiDeleteAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteAgent(requestParameters, options) {
            return localVarFp
                .apiDeleteAgent(requestParameters.org, requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Duplicate an agent by ID
         * @param {AgentApiApiDuplicateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDuplicateAgent(requestParameters, options) {
            return localVarFp
                .apiDuplicateAgent(requestParameters.org, requestParameters.id, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get an agent by ID
         * @param {AgentApiApiGetAgentByGlobalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAgentByGlobalId(requestParameters, options) {
            return localVarFp
                .apiGetAgentByGlobalId(requestParameters.org, requestParameters.id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all agent categories for an organization
         * @param {AgentApiApiGetAgentCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAgentCategories(requestParameters, options) {
            return localVarFp
                .apiGetAgentCategories(requestParameters.org, requestParameters.withCount, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get agents by category
         * @param {AgentApiApiGetAgentsByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAgentsByCategory(requestParameters, options) {
            return localVarFp
                .apiGetAgentsByCategory(requestParameters.org, requestParameters.globalId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all agents for an organization
         * @param {AgentApiApiGetAllAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAllAgents(requestParameters, options) {
            return localVarFp
                .apiGetAllAgents(requestParameters.org, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an agent by ID
         * @param {AgentApiApiUpdateAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateAgent(requestParameters, options) {
            return localVarFp
                .apiUpdateAgent(requestParameters.org, requestParameters.id, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update categories for an agent
         * @param {AgentApiApiUpdateAgentCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateAgentCategories(requestParameters, options) {
            return localVarFp
                .apiUpdateAgentCategories(requestParameters.org, requestParameters.id, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AgentApiFactory = AgentApiFactory;
/**
 * AgentApi - object-oriented interface
 * @export
 * @class AgentApi
 * @extends {BaseAPI}
 */
class AgentApi extends base_1.BaseAPI {
    /**
     * Create a new agent for an organization
     * @param {AgentApiApiCreateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiCreateAgent(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiCreateAgent(requestParameters.org, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an agent by ID
     * @param {AgentApiApiDeleteAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiDeleteAgent(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiDeleteAgent(requestParameters.org, requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Duplicate an agent by ID
     * @param {AgentApiApiDuplicateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiDuplicateAgent(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiDuplicateAgent(requestParameters.org, requestParameters.id, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get an agent by ID
     * @param {AgentApiApiGetAgentByGlobalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiGetAgentByGlobalId(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiGetAgentByGlobalId(requestParameters.org, requestParameters.id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all agent categories for an organization
     * @param {AgentApiApiGetAgentCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiGetAgentCategories(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiGetAgentCategories(requestParameters.org, requestParameters.withCount, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get agents by category
     * @param {AgentApiApiGetAgentsByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiGetAgentsByCategory(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiGetAgentsByCategory(requestParameters.org, requestParameters.globalId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all agents for an organization
     * @param {AgentApiApiGetAllAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiGetAllAgents(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiGetAllAgents(requestParameters.org, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an agent by ID
     * @param {AgentApiApiUpdateAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiUpdateAgent(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiUpdateAgent(requestParameters.org, requestParameters.id, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update categories for an agent
     * @param {AgentApiApiUpdateAgentCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    apiUpdateAgentCategories(requestParameters, options) {
        return (0, exports.AgentApiFp)(this.configuration)
            .apiUpdateAgentCategories(requestParameters.org, requestParameters.id, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AgentApi = AgentApi;
/**
 * AiApi - axios parameter creator
 * @export
 */
const AiApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Check org access to the ai
         * @param {string} org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccess: async (org, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiAccess', 'org', org);
            const localVarPath = `/orgs/{org}/access`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add assistent message to the end of the session history and return delta
         * @param {string} org
         * @param {AIServiceAddMessagePayloadDto} [data] Question, length and voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAddMessage: async (org, data, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiAddMessage', 'org', org);
            const localVarPath = `/org/{org}/addMessage`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AiApiAxiosParamCreator = AiApiAxiosParamCreator;
/**
 * AiApi - functional programming interface
 * @export
 */
const AiApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AiApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check org access to the ai
         * @param {string} org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAccess(org, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAccess(org, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Add assistent message to the end of the session history and return delta
         * @param {string} org
         * @param {AIServiceAddMessagePayloadDto} [data] Question, length and voice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAddMessage(org, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAddMessage(org, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AiApiFp = AiApiFp;
/**
 * AiApi - factory interface
 * @export
 */
const AiApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AiApiFp)(configuration);
    return {
        /**
         * Check org access to the ai
         * @param {AiApiApiAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccess(requestParameters, options) {
            return localVarFp
                .apiAccess(requestParameters.org, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Add assistent message to the end of the session history and return delta
         * @param {AiApiApiAddMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAddMessage(requestParameters, options) {
            return localVarFp
                .apiAddMessage(requestParameters.org, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AiApiFactory = AiApiFactory;
/**
 * AiApi - object-oriented interface
 * @export
 * @class AiApi
 * @extends {BaseAPI}
 */
class AiApi extends base_1.BaseAPI {
    /**
     * Check org access to the ai
     * @param {AiApiApiAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    apiAccess(requestParameters, options) {
        return (0, exports.AiApiFp)(this.configuration)
            .apiAccess(requestParameters.org, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Add assistent message to the end of the session history and return delta
     * @param {AiApiApiAddMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    apiAddMessage(requestParameters, options) {
        return (0, exports.AiApiFp)(this.configuration)
            .apiAddMessage(requestParameters.org, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AiApi = AiApi;
/**
 * UsageApi - axios parameter creator
 * @export
 */
const UsageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get assistant usage for an org
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAssistantUsage: async (orgId, options = {}) => {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('apiGetAssistantUsage', 'orgId', orgId);
            const localVarPath = `/assistant/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get usage statistics
         * @param {string} org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetUsage: async (org, options = {}) => {
            // verify required parameter 'org' is not null or undefined
            (0, common_1.assertParamExists)('apiGetUsage', 'org', org);
            const localVarPath = `/org/{org}/usage`.replace(`{${'org'}}`, encodeURIComponent(String(org)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get whisper usage total minutes
         * @param {string} orgId
         * @param {string} [workspaceId]
         * @param {string} [dateFrom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetWhisperUsage: async (orgId, workspaceId, dateFrom, options = {}) => {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('apiGetWhisperUsage', 'orgId', orgId);
            const localVarPath = `/whisper/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Increase assistant usage for an org
         * @param {string} orgId
         * @param {object} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIncreaseAssistantUsage: async (orgId, data, options = {}) => {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('apiIncreaseAssistantUsage', 'orgId', orgId);
            const localVarPath = `/assistant/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save whisper time used
         * @param {AIServiceWhisperUsageSetPayloadDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSetWhisperUsage: async (data, options = {}) => {
            const localVarPath = `/whisper/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update record in table whisper_subscription_usage
         * @param {string} orgId
         * @param {AIServiceApiUpdateWhisperSubscriptionUsageRequestDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateWhisperSubscriptionUsage: async (orgId, data, options = {}) => {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('apiUpdateWhisperSubscriptionUsage', 'orgId', orgId);
            const localVarPath = `/whisper/subscriptionUsage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UsageApiAxiosParamCreator = UsageApiAxiosParamCreator;
/**
 * UsageApi - functional programming interface
 * @export
 */
const UsageApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UsageApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get assistant usage for an org
         * @param {string} orgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetAssistantUsage(orgId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetAssistantUsage(orgId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get usage statistics
         * @param {string} org
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetUsage(org, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetUsage(org, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get whisper usage total minutes
         * @param {string} orgId
         * @param {string} [workspaceId]
         * @param {string} [dateFrom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetWhisperUsage(orgId, workspaceId, dateFrom, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetWhisperUsage(orgId, workspaceId, dateFrom, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Increase assistant usage for an org
         * @param {string} orgId
         * @param {object} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIncreaseAssistantUsage(orgId, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIncreaseAssistantUsage(orgId, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Save whisper time used
         * @param {AIServiceWhisperUsageSetPayloadDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSetWhisperUsage(data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSetWhisperUsage(data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update record in table whisper_subscription_usage
         * @param {string} orgId
         * @param {AIServiceApiUpdateWhisperSubscriptionUsageRequestDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpdateWhisperSubscriptionUsage(orgId, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpdateWhisperSubscriptionUsage(orgId, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.UsageApiFp = UsageApiFp;
/**
 * UsageApi - factory interface
 * @export
 */
const UsageApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UsageApiFp)(configuration);
    return {
        /**
         * Get assistant usage for an org
         * @param {UsageApiApiGetAssistantUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetAssistantUsage(requestParameters, options) {
            return localVarFp
                .apiGetAssistantUsage(requestParameters.orgId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get usage statistics
         * @param {UsageApiApiGetUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetUsage(requestParameters, options) {
            return localVarFp
                .apiGetUsage(requestParameters.org, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get whisper usage total minutes
         * @param {UsageApiApiGetWhisperUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetWhisperUsage(requestParameters, options) {
            return localVarFp
                .apiGetWhisperUsage(requestParameters.orgId, requestParameters.workspaceId, requestParameters.dateFrom, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Increase assistant usage for an org
         * @param {UsageApiApiIncreaseAssistantUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIncreaseAssistantUsage(requestParameters, options) {
            return localVarFp
                .apiIncreaseAssistantUsage(requestParameters.orgId, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Save whisper time used
         * @param {UsageApiApiSetWhisperUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSetWhisperUsage(requestParameters = {}, options) {
            return localVarFp
                .apiSetWhisperUsage(requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update record in table whisper_subscription_usage
         * @param {UsageApiApiUpdateWhisperSubscriptionUsageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpdateWhisperSubscriptionUsage(requestParameters, options) {
            return localVarFp
                .apiUpdateWhisperSubscriptionUsage(requestParameters.orgId, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.UsageApiFactory = UsageApiFactory;
/**
 * UsageApi - object-oriented interface
 * @export
 * @class UsageApi
 * @extends {BaseAPI}
 */
class UsageApi extends base_1.BaseAPI {
    /**
     * Get assistant usage for an org
     * @param {UsageApiApiGetAssistantUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    apiGetAssistantUsage(requestParameters, options) {
        return (0, exports.UsageApiFp)(this.configuration)
            .apiGetAssistantUsage(requestParameters.orgId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get usage statistics
     * @param {UsageApiApiGetUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    apiGetUsage(requestParameters, options) {
        return (0, exports.UsageApiFp)(this.configuration)
            .apiGetUsage(requestParameters.org, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get whisper usage total minutes
     * @param {UsageApiApiGetWhisperUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    apiGetWhisperUsage(requestParameters, options) {
        return (0, exports.UsageApiFp)(this.configuration)
            .apiGetWhisperUsage(requestParameters.orgId, requestParameters.workspaceId, requestParameters.dateFrom, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Increase assistant usage for an org
     * @param {UsageApiApiIncreaseAssistantUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    apiIncreaseAssistantUsage(requestParameters, options) {
        return (0, exports.UsageApiFp)(this.configuration)
            .apiIncreaseAssistantUsage(requestParameters.orgId, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Save whisper time used
     * @param {UsageApiApiSetWhisperUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    apiSetWhisperUsage(requestParameters = {}, options) {
        return (0, exports.UsageApiFp)(this.configuration)
            .apiSetWhisperUsage(requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update record in table whisper_subscription_usage
     * @param {UsageApiApiUpdateWhisperSubscriptionUsageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageApi
     */
    apiUpdateWhisperSubscriptionUsage(requestParameters, options) {
        return (0, exports.UsageApiFp)(this.configuration)
            .apiUpdateWhisperSubscriptionUsage(requestParameters.orgId, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.UsageApi = UsageApi;
/**
 * WhisperApi - axios parameter creator
 * @export
 */
const WhisperApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete asisstant response and user request
         * @param {string} sessionId
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteWhisperMessage: async (sessionId, messageId, options = {}) => {
            // verify required parameter 'sessionId' is not null or undefined
            (0, common_1.assertParamExists)('apiDeleteWhisperMessage', 'sessionId', sessionId);
            // verify required parameter 'messageId' is not null or undefined
            (0, common_1.assertParamExists)('apiDeleteWhisperMessage', 'messageId', messageId);
            const localVarPath = `/whisper/sessions/{sessionId}/messages/{messageId}`
                .replace(`{${'sessionId'}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${'messageId'}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user ai sessions for attach, and create new if not exist
         * @param {AIServiceGetWhisperSessionsPayloadDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetCreateWhisperSessions: async (data, options = {}) => {
            const localVarPath = `/whisper/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user ai sessions for attach
         * @param {string} [attachmentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetWhisperSessions: async (attachmentId, options = {}) => {
            const localVarPath = `/whisper/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            if (attachmentId !== undefined) {
                localVarQueryParameter['attachmentId'] = attachmentId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update last assistant content
         * @param {string} sessionId
         * @param {AIServiceUpLastPayloadDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpLastWhisperContent: async (sessionId, data, options = {}) => {
            // verify required parameter 'sessionId' is not null or undefined
            (0, common_1.assertParamExists)('apiUpLastWhisperContent', 'sessionId', sessionId);
            const localVarPath = `/whisper/sessions/{sessionId}/uplast`.replace(`{${'sessionId'}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication internal required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, 'authorization', configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(data, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WhisperApiAxiosParamCreator = WhisperApiAxiosParamCreator;
/**
 * WhisperApi - functional programming interface
 * @export
 */
const WhisperApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WhisperApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete asisstant response and user request
         * @param {string} sessionId
         * @param {string} messageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeleteWhisperMessage(sessionId, messageId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeleteWhisperMessage(sessionId, messageId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get user ai sessions for attach, and create new if not exist
         * @param {AIServiceGetWhisperSessionsPayloadDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetCreateWhisperSessions(data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetCreateWhisperSessions(data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get user ai sessions for attach
         * @param {string} [attachmentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGetWhisperSessions(attachmentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGetWhisperSessions(attachmentId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update last assistant content
         * @param {string} sessionId
         * @param {AIServiceUpLastPayloadDto} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpLastWhisperContent(sessionId, data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpLastWhisperContent(sessionId, data, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.WhisperApiFp = WhisperApiFp;
/**
 * WhisperApi - factory interface
 * @export
 */
const WhisperApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WhisperApiFp)(configuration);
    return {
        /**
         * Delete asisstant response and user request
         * @param {WhisperApiApiDeleteWhisperMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeleteWhisperMessage(requestParameters, options) {
            return localVarFp
                .apiDeleteWhisperMessage(requestParameters.sessionId, requestParameters.messageId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get user ai sessions for attach, and create new if not exist
         * @param {WhisperApiApiGetCreateWhisperSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetCreateWhisperSessions(requestParameters = {}, options) {
            return localVarFp
                .apiGetCreateWhisperSessions(requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get user ai sessions for attach
         * @param {WhisperApiApiGetWhisperSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGetWhisperSessions(requestParameters = {}, options) {
            return localVarFp
                .apiGetWhisperSessions(requestParameters.attachmentId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update last assistant content
         * @param {WhisperApiApiUpLastWhisperContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpLastWhisperContent(requestParameters, options) {
            return localVarFp
                .apiUpLastWhisperContent(requestParameters.sessionId, requestParameters.data, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.WhisperApiFactory = WhisperApiFactory;
/**
 * WhisperApi - object-oriented interface
 * @export
 * @class WhisperApi
 * @extends {BaseAPI}
 */
class WhisperApi extends base_1.BaseAPI {
    /**
     * Delete asisstant response and user request
     * @param {WhisperApiApiDeleteWhisperMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhisperApi
     */
    apiDeleteWhisperMessage(requestParameters, options) {
        return (0, exports.WhisperApiFp)(this.configuration)
            .apiDeleteWhisperMessage(requestParameters.sessionId, requestParameters.messageId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get user ai sessions for attach, and create new if not exist
     * @param {WhisperApiApiGetCreateWhisperSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhisperApi
     */
    apiGetCreateWhisperSessions(requestParameters = {}, options) {
        return (0, exports.WhisperApiFp)(this.configuration)
            .apiGetCreateWhisperSessions(requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get user ai sessions for attach
     * @param {WhisperApiApiGetWhisperSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhisperApi
     */
    apiGetWhisperSessions(requestParameters = {}, options) {
        return (0, exports.WhisperApiFp)(this.configuration)
            .apiGetWhisperSessions(requestParameters.attachmentId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update last assistant content
     * @param {WhisperApiApiUpLastWhisperContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhisperApi
     */
    apiUpLastWhisperContent(requestParameters, options) {
        return (0, exports.WhisperApiFp)(this.configuration)
            .apiUpLastWhisperContent(requestParameters.sessionId, requestParameters.data, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.WhisperApi = WhisperApi;
//# sourceMappingURL=api.js.map